import type { ReactNode } from "react";
import { Stack } from "react-bootstrap";
import { SelectableChip } from "./SelectableChip";

type ChipGroupProps<S extends string> = {
  options: { label: ReactNode; value: S }[];
  value: S[];
  onChange: (value: S[]) => void;
};

export function ChipGroup<S extends string>({ options, value, onChange }: ChipGroupProps<S>) {
  return (
    <Stack direction="horizontal" gap={2}>
      {options.map((o) => (
        <SelectableChip
          key={o.value}
          checked={value.includes(o.value)}
          onChange={(checked) => onChange(checked ? [...value, o.value] : value.filter((v) => v !== o.value))}
        >
          {o.label}
        </SelectableChip>
      ))}
    </Stack>
  );
}
